import { deleteCookie, setCookie } from '@cian/utils/lib/browser/cookie';
import {
  FOREVER_REGION_ID_COOKIE_KEY,
  SESSION_REGION_ID_COOKIE_KEY,
  SESSION_REGION_NAME_COOKIE_KEY,
  FOREVER_REGION_NAME_COOKIE_KEY,
  SESSION_MAIN_TOWN_REGION_ID_COOKIE_KEY,
  FOREVER_MAIN_TOWN_REGION_ID_COOKIE_KEY,
} from '../../../../constants/geoSwitcher';
import { IRegion } from '../../../../types/geoSwitcher';

export const setRegionCookies = (selectedRegion: IRegion) => {
  const { mainTownId, displayName } = selectedRegion;
  // Math.abs тут до тех пор, пока саджесты не научатся в отрицательные id
  const id = Math.abs(selectedRegion.id);
  const currentDate = new Date();
  const dateThroughOneYear = new Date(currentDate.setFullYear(currentDate.getFullYear() + 1));
  const cookieDomain = '.cian.ru';

  setCookie(SESSION_REGION_ID_COOKIE_KEY, `${id}`, {
    domain: cookieDomain,
    secure: false,
  });
  setCookie(SESSION_REGION_NAME_COOKIE_KEY, `${displayName}`, {
    domain: cookieDomain,
    secure: false,
  });

  setCookie(FOREVER_REGION_ID_COOKIE_KEY, `${id}`, {
    domain: cookieDomain,
    expires: dateThroughOneYear,
    secure: false,
  });
  setCookie(FOREVER_REGION_NAME_COOKIE_KEY, `${displayName}`, {
    domain: cookieDomain,
    expires: dateThroughOneYear,
    secure: false,
  });

  if (mainTownId) {
    setCookie(SESSION_MAIN_TOWN_REGION_ID_COOKIE_KEY, `${mainTownId}`, {
      domain: cookieDomain,
      secure: false,
    });
    setCookie(FOREVER_MAIN_TOWN_REGION_ID_COOKIE_KEY, `${mainTownId}`, {
      domain: cookieDomain,
      expires: dateThroughOneYear,
      secure: false,
    });
  } else {
    deleteCookie(SESSION_MAIN_TOWN_REGION_ID_COOKIE_KEY, { domain: cookieDomain });
    deleteCookie(FOREVER_MAIN_TOWN_REGION_ID_COOKIE_KEY, { domain: cookieDomain });
  }
};
